module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jcHhS"))).then(() => parcelRequire('f4eak'));